<script>
	export default {
		name: 'midiasection',

		methods: {
			next() {
				let dom = document.querySelectorAll('nav li a');
				dom.forEach(function(element) {
					element.addEventListener('click', (e) => {
						console.log(e.target)
					})
				}, this);
			},
		},
		created() {
			this.$nextTick(function() {
			});
		}
	}
</script>

<template>
	<div id="midia" class="row">
		<div class="container">
			<section class="section">
					<h2 class="title big-title">Voto Legal na mídia</h2>
				<ul class="midia-wrap">
					<li class="img-content tedx">
						<a href="https://www.youtube.com/watch?v=49J9g5gCcWM&t=2s" target="_blank">TEDx</a>
					</li>
					<li class="img-content el-pais">
						<a href="https://brasil.elpais.com/brasil/2016/07/08/politica/1468011468_841041.html" target="_blank">El País</a>
					</li>
					<li class="img-content cbn">
						<a href="http://cbn.globoradio.globo.com/sao-paulo/2016/09/23/NA-RETA-FINAL-DIVERSOS-SITES-E-APLICATIVOS-AJUDAM-O-ELEITOR-A-DEFINIR-O-VOTO.htm" target="_blank">CBN</a>
					</li>
					<li class="img-content estadao">
						<a href="http://politica.estadao.com.br/noticias/geral,iniciativas-querem-estimular-doacoes-de-pessoa-fisica,10000053676" target="_blank">Estadão</a>
					</li>
					<li class="img-content jornal-nacional">
						<a href="http://g1.globo.com/jornal-nacional/noticia/2016/08/eleicoes-de-2016-tem-novidade-empresas-nao-podem-fazer-doacoes.html" target="_blank">Jornal Nacional</a>
					</li>
					<li class="img-content folha-sp">
						<a href="http://www1.folha.uol.com.br/tec/2016/06/1783365-por-transparencia-grupo-quer-usar-tecnologia-do-bitcoin-em-eleicoes-de-sp.shtml" target="_blank">Folha de São Paulo</a>
					</li>
					<li class="img-content super-interessante">
						<a href="https://super.abril.com.br/ideias/quem-e-que-paga-a-politica" target="_blank">Super Interessante</a>
					</li>
					<li class="img-content nexo">
						<a href="https://www.nexojornal.com.br/ensaio/2016/Elei%C3%A7%C3%B5es-e-a-oportunidade-de-um-maior-engajamento-dos-cidad%C3%A3os-com-seus-representantes" target="_blank">Nexo</a>
					</li>
					<li class="img-content yahoo">
						<a href="https://br.noticias.yahoo.com/doacoes-de-marina-silva-serao-registradas-em-blockchain-entenda-145118346.html" target="_blank">Yahoo</a>
					</li>
					<li class="img-content portal-bitcoin">
						<a href="https://portaldobitcoin.com/marina-silva-usa-blockchain-para-financiar-campanha-e-arrecada-r-100-mil-em-quatro-dias/" target="_blank">Portal do Bitcoin</a>
					</li>
					<li class="img-content livecoins">
						<a href="https://livecoins.com.br/marina-silva-utilizando-blockchain-da-decred-para-deixar-transparente-o-financiamento-coletivo-de-sua-campanha-eleitoral/" target="_blank">Livecoins</a>
					</li>
				</ul>
			</section>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	#midia {
		background-color: white;
		color: rgb(53, 211, 79);

	}

	#midia h2 {
		text-align: center;
	}

	.midia-wrap {
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		text-align: center;
		margin-top: 5rem;
		padding: 0;

		@media (max-width: 700px) {
			margin-top: 2em;
		}

		&::after {
			content: '';
			display: table;
			clear: both;
		}

		.img-content {
			display: inline-block;
			float: none;

			margin-top: 20px;
			margin-right: 1.5em;
			margin-bottom: 40px;
			margin-left: 1.5em;
			overflow: hidden;

			text-indent: 110%;
			white-space: nowrap;

			background-repeat: no-repeat;

			direction: ltr;

			@media (min-width: 480px) {
				display: inline-block;
				float: none;
				margin-right: 2.5em;
				margin-left: 2.5em;
			}

			@media (min-width: 800px) {
				margin-top: 30px;
				margin-bottom: 30px;
			}
		}
	}

	.midia-wrap {
		padding: 0;
	}

	.midia-wrap a {
		display: block;
		height: 100%;
	}

	.tedx {
		background-image: url("../../img/namidia/logo-TEDx-branco.png");
		width: 148px;
		height: 54px;
	}

	.cbn {
		background-image: url("../../img/namidia/logo-cbn-branco.png");
		width: 136px;
		height: 54px;
	}

	.el-pais {
		background-image: url("../../img/namidia/logo-elpais-branco.png");
		width: 205px;
		height: 54px;
	}

	.estadao {
		background-image: url("../../img/namidia/logo-estadao-branco.png");
		width: 216px;
		height: 54px;
	}

	.jornal-nacional {
		background-image: url("../../img/namidia/logo-jn-branco.png");
		width: 100px;
		height: 54px;
	}

	.nexo {
		background-image: url("../../img/namidia/logo-nexo-branco.png");
		width: 202px;
		height: 54px;
	}

	.super-interessante {
		background-image: url("../../img/namidia/logo-superinteressante-branco.png");
		width: 152px;
		height: 54px;
	}

	.folha-sp {
		background-image: url("../../img/namidia/logo-folha-branco.png");
		width: 200px;
		height: 54px;
		background-size: contain;

		@media (min-width: 768px) {
			width: 290px;
			height: 54px;
		}
	}

	.yahoo {
		background-image: url("../../img/namidia/yahoo.png");
		width: 156px;
		height: 54px;
	}

	.livecoins {
		background-image: url("../../img/namidia/livecoins.png");
		width: 156px;
		height: 54px;
	}

	.portal-bitcoin {
		background-image: url("../../img/namidia/portal-bitcoin.png");
		width: 224px;
		height: 54px;
		background-size: contain;

		@media (min-width: 768px) {
			width: 224px;
			height: 57px;
		}
	}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/midiasection.vue